export default __webpack_public_path__ + "static/media/petrolpump.04e718b9.svg";